import { ComplianceLevel, SET_COMPLIANCE_LEVEL, SetComplianceLevelAction } from './types';

export function setComplianceLevel(complianceLevel: ComplianceLevel): SetComplianceLevelAction {
	return {
		type: SET_COMPLIANCE_LEVEL,
		payload: complianceLevel,
	};
}
